import { Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { HlmCheckboxImports } from '@spartan-ng/helm/checkbox';

@Component({
  selector: 'app-checkbox-submenu-item',
  imports: [HlmCheckboxImports],
  templateUrl: './checkbox-submenu-item.component.html',
})
export class CheckboxSubmenuItemComponent {
  formcontrol = input.required<AbstractControl<{ id: string }[]>>();
  item = input.required<{ id: string; nom: string }>();

  isChecked = (item: string, formControl: AbstractControl) =>
    formControl.value.findIndex((x: { id: string }) => x.id === item) > -1;

  toggleCheckbox() {
    const index = this.formcontrol().value.findIndex((x) => x.id === this.item().id);
    if (index === -1) {
      this.formcontrol().setValue([...this.formcontrol().value, this.item()]);
    } else {
      this.formcontrol().setValue([...this.formcontrol().value.filter((x) => x.id !== this.item().id)]);
    }
  }
}
